import React, { useState, useRef } from "react";
import axios from "axios";
import Recaptcha from "react-google-invisible-recaptcha";

import Alert from "../Components/Alert";
import Modal from "../Components/Modal";
import Loader from "../Components/Loading";

import RegistrationForm from "../Account/RegistrationForm";

const RegistrationModal = (props) => {
    const [state, setState] = useState({
        errors: {},
        alert: false,
        alertMessage: "",
        isSubmitting: false,
        modalOpen: true,
    });

    const formValues = useRef({});
    const recaptcha = useRef(null);
    const form = useRef({});

    const hide = () => {
        document.getElementById("registrationModal").style.display = "none";
        setState({
            ...state,
            modalOpen: true
        });
    };

    const handleCustomerSubmit = () => {
        const recaptchaResponse = recaptcha.current.getResponse();
        const values = formValues.current;

        setState({
            ...state,
            isSubmitting: true,
            alert: false,
            alertMessage: "",
        });

        const newCustomerInfo = {
            customer: {
                firstname: values.firstName,
                lastname: values.lastName,
                email: values.email,
            },
            password: values.password,
            recaptcha: recaptchaResponse,
        };

        const credentials = {
            email: values.email,
            password: values.password,
        };

        axios.post("/api/sellers", newCustomerInfo)
            .then(() => axios.post("/customer/account/login", credentials))
            .then(() => {
                setState({
                    ...state,
                    modalOpen: false,
                    isSubmitting: false
                });
                window.location = "/customer/account";
            })
            .catch(err => {
                recaptcha.current.reset();
                setState({
                    ...state,
                    isSubmitting: false,
                    alert: true,
                    alertMessage: err.response.data,
                });
            });
    };

    return (
        <Modal
            open={state.modalOpen}
            title="Register with LabX"
            key="form-modal"
            id="registrationModal"
            size="lg"
            close={hide}
            {...props}
        >
            <Alert className="alert-danger" visible={state.alert}>
                {state.alertMessage}
            </Alert>
            <Recaptcha
                ref={(ref) => recaptcha.current = ref }
                sitekey={localStorage.getItem("recaptchaSiteKey")}
                onResolved={handleCustomerSubmit}
            />
            { state.isSubmitting
                ? <Loader />
                : <RegistrationForm
                    defaults={formValues.current}
                    contextRef={form}
                    onSubmit={(e) => {
                        e.preventDefault();
                        formValues.current = form.current.getValues(e.target);
                        recaptcha.current.execute();
                    }}
                />
            }
        </Modal>
    );
};

export { RegistrationModal };
